<template>
  <div>
    <card-box v-if="userType==0" class="mySignature" title="我的手写签名">
      <el-button slot="tt_r" type="primary" class="butn" @click="Signature()">添加签名</el-button>
      <el-carousel
        class="list"
        :autoplay="false"
        :loop="false"
        :interval="5000"
        v-loading="loading"
        indicator-position="none"
        :arrow="mySignature.length>1?'always':'never'"
      >
        <el-carousel-item class="carousel_item" v-for="(item,index) in mySignature" :key="index">
          <div v-for="(item2,index) in item" :key="index">
            <div class="list_li">
              <div class="img" @mouseover="mouseover($event)" @mouseout="mouseout($event)">
                <div @click="present=item2;del_seal_dialog=true;" class="delButn" v-if="item2.remark != '系统签名'">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#el-icon-my-deletestamp'" />
                  </svg>
                </div>
                <el-image :src="item2.signatureSaveID | fileToUrl(mySignature_file)" fit="contain">
                  <div slot="error" class="image-slot image-slot_one" v-if="!$options.filters.fileToUrl(item2.signatureSaveID,mySignature_file,false)">
                    <img src="@/assets/img/user/Signature_s.png" />
                    <p>签名丢失</p>
                  </div>
                </el-image>
                <div class="botButn">
                  <div @click="Modify(item2 , mySignature_file)" v-if="item2.remark != '系统签名'">
                    <img src="@/assets/img/user/cg_icon2.png" />
                    修改
                  </div>
                  <div @click="Default(item2,1)">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="item2.defaultSignature==0?'#el-icon-my-first':'#el-icon-my-default'" />
                    </svg>
                    {{item2.defaultSignature==1?'取消默认':'设为默认'}}
                  </div>
                </div>
                <div class="default">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="item2.defaultSignature==1?'#el-icon-my-first':'#el-icon-my-default'" />
                  </svg>
                </div>
              </div>
              <div class="msg">
                <div>
                  <span class="key">名称</span>
                  <span class="text">{{item2.name}}</span>
                </div>
                <div>
                  <span class="key">创建时间</span>
                  <span class="text">{{item2.creationDate.split(" ")[0]}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <div class="No_data" v-if="mySignature.length==0">
          <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;" />
          <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无数据</p>
        </div>
      </el-carousel>
    </card-box>
    <card-box class="mySeal" title="我的电子印章">
      <el-button slot="tt_r" type="primary" @click="Purchase_package" class="butn" v-if="userType==1">添加印章</el-button>
      <el-carousel
        v-loading="loading"
        class="list"
        :autoplay="false"
        :loop="false"
        :interval="5000"
        indicator-position="none"
        :arrow="mySeal.length>1?'always':'never'"
      >
        <el-carousel-item class="carousel_item" v-for="(item,index) in mySeal" :key="index">
          <div v-for="(item2,index) in item" :key="index">
            <div class="list_li">
              <!-- certification印证审核状态 0 等待认证 1：认证成功 2：认证失败 -->
              <div class="img" v-if="item2.certification == 0">
                <el-image :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                  <div slot="error" class="image-slot image-slot_one" v-if="!$options.filters.fileToUrl(item2.sealSaveID,mySeal_file,false)">
                    <img src="@/assets/img/user/signature.png" />
                    <p>签章丢失</p>
                  </div>
                </el-image>
                <div class="img_shen" v-if="$options.filters.fileToUrl(item2.sealSaveID,mySeal_file,false)">
                  <img src="@/assets/img/user/shenhe.png" />
                </div>
              </div>
              <div class="img" v-if="item2.certification == 2" @mouseover="mouseover($event)" @mouseout="mouseout($event)">
                <el-image :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                  <div slot="error" class="image-slot_one" v-if="!$options.filters.fileToUrl(item2.sealSaveID,mySeal_file,false)">
                    <img src="@/assets/img/user/signature.png" />
                    <p>签章丢失</p>
                  </div>
                </el-image>
                <!-- 未通过 -->

                <div
                  class="img_shen"
                  style="text-align: center; background: rgba(0,0,0,0);"
                  v-if="$options.filters.fileToUrl(item2.sealSaveID,mySeal_file,false)"
                >
                  <img style="width: 69%;height: 47%;margin-top: 46px;" src="@/assets/img/user/weirenz.png" />
                </div>

                <div @click="present=item2;del_seal_dialog_2=true;" class="delButn" v-if="userType==1">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#el-icon-my-deletestamp'" />
                  </svg>
                </div>
              </div>
              <div class="img" v-if="item2.certification == 1" @mouseover="mouseover($event)" @mouseout="mouseout($event)">
                <div v-if="item2.whetherOnline==0 && userType==1" @click="present=item2;del_seal_dialog_2=true;" class="delButn">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#el-icon-my-deletestamp'" />
                  </svg>
                </div>
                <el-image :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                  <div slot="error" class="image-slot_one" v-if="!$options.filters.fileToUrl(item2.sealSaveID,mySeal_file,false)">
                    <img src="@/assets/img/user/signature.png" />
                    <p>签章丢失</p>
                  </div>
                </el-image>
                <!-- 线上 注销的 -->
                <div class="img_shen" v-if="item2.status===2" style="text-align: center; background: rgba(0,0,0,0);">
                  <img style="width: 69%;height: 47%;margin-top: 46px;" src="@/assets/img/user/cancel.png" />
                </div>
                <div class="botButn" v-if="userType==1">
                  <!--                                                      <div @click="add_seal_dialog = true" >-->
                  <!--                                                        <img src="@/assets/img/user/cg_icon2.png" />修改-->
                  <!--                                                      </div>-->
                  <div @click="Default(item2,2)">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="item2.defaultSeal==0?'#el-icon-my-first':'#el-icon-my-default'" />
                    </svg>
                    {{item2.defaultSeal==1?'取消默认':'设为默认'}}
                  </div>
                </div>
                <div class="default" v-if="userType==1">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="item2.defaultSeal==1?'#el-icon-my-first':'#el-icon-my-default'" />
                  </svg>
                </div>
                <div class="default_right">
                  <img v-if="item2.whetherOnline==0" src="@/assets/img/user/yun.png" />
                  <img v-if="item2.whetherOnline==1" src="@/assets/img/user/ukey.png" />
                </div>
              </div>
              <div class="msg">
                <div v-if="item2.certification != 2">
                  <span class="key">名称</span>
                  <span class="text">{{item2.name}}</span>
                </div>
                <div v-if="item2.certification != 2 &&item2.whetherOnline==0">
                  <span class="key">创建时间</span>
                  <span class="text">
                    {{ item2.creationDate?new Date(Date.parse(item2.creationDate.replace(/-/g,
                    "/"))):'' | timeFormat("yyyy-mm-dd") }}
                  </span>
                </div>
                <div v-if="item2.certification != 2 &&item2.whetherOnline==1">
                  <span class="key">同步时间</span>
                  <span class="text">
                    {{ item2.synchronisedTime? new
                    Date(Date.parse(item2.synchronisedTime.replace(/-/g, "/"))) :'' | timeFormat("yyyy-mm-dd")}}
                  </span>
                </div>
                <div v-if="item2.certification != 2 &&item2.whetherOnline==1">
                  <span class="key">备案单位</span>
                  <span class="text">{{item2.sealRecordUnitName}}</span>
                </div>
                <div v-if="item2.certification != 2">
                  <span class="key">印章类型</span>
                  <span class="text">{{sealTypeS[item2.sealType]}}</span>
                </div>

                <div v-if="item2.certification == 2" style="color:rgba(171,171,171,1);margin-bottom: 10px">
                  因该{{item2.errorReason}}
                  <span style="color: red">{{item2.errorReason? item2.errorReason.split(",")[0]:'其他'}}</span>
                  印章不通过，请点击右上角删除 印章。
                </div>
                <div v-if="item2.certification == 2">
                  <span class="key">驳回备注</span>
                  <span class="text" style="color: red">{{item2.errorReason?item2.errorReason.split(",")[1]:' '}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <div class="No_data" v-if="mySeal.length==0">
          <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;" />
          <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无数据</p>
        </div>
      </el-carousel>
    </card-box>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="签名删除" :visible.sync="del_seal_dialog" width="617" center>
      <div class="affirm_del_seal">
        <div>您确定删除此签章</div>
        <el-image :src="present.signatureSaveID | fileToUrl(mySignature_file)" fit="contain"></el-image>
        <div class="hint">印章删除之后将不可恢复，请谨慎删除。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" @click="del_seal()" type="primary">确认删除</el-button>
        <el-button @click="del_seal_dialog=false" plain>取消删除</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="印章删除" :visible.sync="del_seal_dialog_2" width="617" center>
      <div class="affirm_del_seal">
        <div>您确定删除此签章</div>
        <el-image :src="present.sealSaveID | fileToUrl(mySeal_file)" fit="contain"></el-image>
        <div class="hint">印章删除之后将不可恢复，请谨慎删除。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" @click="del_seal_2(present)" type="primary">确认删除</el-button>
        <el-button @click="del_seal_dialog_2=false" plain>取消删除</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="添加签章" :visible.sync="add_seal_dialog" width="617" center :before-close="del_dialog">
      <div class="affirm_add_seal">
        <div>
          <el-upload action :http-request="img_upload" accept=".png" :show-file-list="false" :data="{key:0}" :before-upload="beforeAvatarUpload">
            <el-image :src="companyAuthInfo.resourceEntitys[0]?companyAuthInfo.resourceEntitys[0].filePath:''">
              <div slot="error">
                <img src="@/assets/img/user/seal.png" alt />
              </div>
            </el-image>
            <div class="add_seal_test">点击上传签章图片</div>
            <div class="add_seal_test_1">仅支持.png格式图片，文件小于2MB，长，宽均为166像素</div>
            <div class="add_seal_test_1">上传图片必须为透明背景且签章名称与企业名称一致</div>
          </el-upload>
        </div>
      </div>
      <div class="affirm_test" v-if="!companyAuthInfo.resourceEntitys[0].filePath">
        <div>背景透明签章制作过程参考：</div>
        <div>1、在一张白纸上盖章/签章</div>
        <div>2、手机拍下刚刚的盖章/签章</div>
        <div>
          3、传到电脑使用PS，对图章/签章抠图（去掉白色背景）
          <span class="xiey" @click="video_seal = true">查看参考视频</span>
        </div>
        <div>4、生成背景透明的PNG格式图片</div>
      </div>
      <div class="affirm_test" v-if="companyAuthInfo.resourceEntitys[0].filePath">
        <el-form ref="edit_contact_form" :model="companyAuthInfo" label-width="80px" :rules="companyAuthInfo_rules">
          <el-form-item label="印章名称" prop="name">
            <el-input v-model="companyAuthInfo.name" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="印章类型" prop="remarkName">
            <el-select id="guang_b" v-model="companyAuthInfo.sealType" placeholder="请选择">
              <el-option label="法定名称章(公章)" :value="1" v-if="ndt.length<1"></el-option>
              <el-option label="财务专用章" :value="2"></el-option>
              <!--                            <el-option label="发票专用章" :value="3"></el-option>-->
              <el-option label="合同专用章" :value="4"></el-option>
              <el-option label="法定代表人名章" :value="5"></el-option>
              <!--                            <el-option label="其他类型章" :value="9"></el-option>-->
            </el-select>
          </el-form-item>
          <el-form-item label="印章规格" prop="remarkName">
            <el-select id="guang_b_s" v-model="companyAuthInfo.size" placeholder="请选择">
              <el-option label="一般的公章：40*40" :value="1"></el-option>
              <el-option label="合同章：40*40" :value="2"></el-option>
              <!--                            <el-option label="发票章：40*30" :value="3"></el-option>-->
              <el-option label="法人章：20*20" :value="4"></el-option>
              <el-option label="财务章：38*38" :value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loding_s" :disabled="companyAuthInfo.resourceEntitys[0].filePath?false:true" @click="add_seal()" type="primary">下一步</el-button>
        <el-button @click="del_dialog" plain>取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="添加签名"
      :visible.sync="add_signature_dialog"
      width="617"
      center
      :before-close="handleDialogClose"
    >
      <div class="signature_div">
        <div id="pay">
          <img :src="qrcodeBase64" class="avatar" />
          <div class="signature_test">请使用手机扫一扫功能扫描此二维码,请勿刷新页面</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="修改签名" :visible.sync="mod_signature_dialog" width="617" center>
      <div class="mod_img">
        <el-image :src="urls" fit="contain"></el-image>
      </div>
      <el-form ref="user" :model="user" :rules="rules" label-width="100px" class="_el-form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="user.name" maxlength="11" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-button :loading="loding_s" class="account-butn" @click="Confirm_changes_one('user')">确认更改</el-button>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="印章制作视频" :visible.sync="video_seal" width="617" center>
      <div style="text-align: center;width: auto;max-width: 100%">
        <get-video style="text-align: center;width: auto;max-width: 100%;height: auto;max-height: 340px"></get-video>
        <el-button class="account-butn" @click="video_seal=false">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import getVideo from '@/views/videoSeal.vue'
export default {
  name: 'MySignature',
  data() {
    return {
      loading: false,
      mySignature: [],
      mySeal: [],
      nweData: [],
      userType: 0,
      authenStatus: 0,
      mySignature_file: [],
      mySeal_file: [],
      del_seal_dialog: false,
      del_seal_dialog_2: false,
      add_seal_dialog: false,
      loding_s: false,
      video_seal: false,
      add_signature_dialog: false,
      mod_signature_dialog: false,
      present: {},
      sealTypeS: {
        '01': '法定名称章(公章)',
        '02': '财务专用章',
        '04': '合同专用章',
        '05': '法定代表人名章'
      },
      rules: {
        name: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      user: {},
      companyAuthInfo: {
        resourceEntitys: [
          {
            attribute: '上传刻章',
            fileId: '',
            filePath: '',
            type: 9
          }
        ],
        sealType: 2,
        size: 1,
        name: ''
      },
      companyAuthInfo_rules: {
        name: [
          {
            required: true,
            message: '请输入印章名称',
            trigger: 'blur'
          }
        ]
      },
      qrcodeBase64: '',
      data: {},
      data1: {},
      urls: {},
      mo_myseal: {},
      mod_mySignature: {},
      certificationData: {},
      new_url: '',
      ndt: []
    }
  },
  components: {
    getVideo
  },
  async created() {
    this.userType = this.$SIF.getLocalStorage('userInfo').userType
    this.authenStatus = this.$SIF.getLocalStorage('userInfo').authenStatus
    if (this.userType == 0) {
      this.get_mySignature()
    }
    // 1：企业用户  0：个人用户
    if (this.userType == 1) {
      await this.get_certificationSeals()
    }
    console.log(2222)
    this.get_mySeal()
    var pagename = window.location.host
    if (pagename.indexOf('aiosign.com') >= 0) {
      this.new_url = 'https://' + pagename
    } else {
      this.new_url = this.$SIF.get_url
    }
  },
  methods: {
    mouseover($event) {
      $event.currentTarget.className = 'img active'
    },
    mouseout($event) {
      $event.currentTarget.className = 'img'
    },
    del_dialog() {
      this.companyAuthInfo.name = ''
      this.companyAuthInfo.sealType = 2
      this.companyAuthInfo.size = 1
      this.companyAuthInfo.resourceEntitys[0].fileId = ''
      this.companyAuthInfo.resourceEntitys[0].filePath = ''
      this.add_seal_dialog = false
    },
    // 印章认证失败
    //
    get_certificationFailure() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.seal + '/contract-seal/query/certificationFailure',
        succFun: res => {
          this.certificationData = res.data
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 企业用户时 获取所有认证失败的印章
    get_certificationSeals() {
      return new Promise((reslove, renject) => {
        this.$SIF.httpPost({
          url: this.$SIF._serve.seal + '/contract-seal/query/certificationFailure',
          succFun: res => {
            this.certificationData = res.data
            reslove(true)
          },
          failFun: res => {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      })
    },
    // 监听关闭二维码弹窗
    handleDialogClose() {
      this.get_mySignature()
      this.add_signature_dialog = false
    },
    //修改签名
    Modify(i, a) {
      this.user = {
        ...i
      }
      a.forEach(url => {
        if (url.id == i.signatureSaveID) {
          this.urls = url.downloadUrl
        }
      })
      this.mod_signature_dialog = true
    },
    //修改签名
    Confirm_changes_one(user) {
      this.$refs[user].validate(valid => {
        if (valid) {
          this.loding_s = true
          this.$SIF.httpPost({
            url: this.$SIF._serve.signature + '/contract-signature/update',
            data: {
              ...this.user
            },
            succFun: res => {
              this.$message({
                message: res.msg,
                type: 'success'
              })
              this.get_mySignature()
              this.loding_s = false
              this.mod_signature_dialog = false
            },
            failFun: res => {
              this.loding_s = false
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        }
      })
    },
    //添加印章
    Purchase_package() {
      if (this.authenStatus == 1) {
        if (this.nweData.length >= 20) {
          this.$message({
            message: '印章数量已达上限，请删除后重新添加',
            type: 'warning'
          })
          return
        }
        this.add_seal_dialog = true
      } else {
        this.$confirm('未认证用户不能上传印章，去认证', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            name: this.userType == 1 ? 'enterpriseAuthe' : 'personalAuthentication'
          })
        })
      }
    },
    // 设置默认
    Default(i, a) {
      if (i.defaultSignature == 0) {
        i.defaultSignature = 1
      } else {
        i.defaultSignature = 0
      }
      if (i.defaultSeal == 0) {
        i.defaultSeal = 1
      } else {
        i.defaultSeal = 0
      }
      if (a == 1) {
        this.url = this.$SIF._serve.signature + '/contract-signature/update/defaultSignature'
      } else {
        this.url = this.$SIF._serve.seal + '/contract-seal/update/defaultSeal'
      }
      this.$SIF.httpPost({
        url: this.url,
        data: {
          id: i.id,
          defaultSignature: i.defaultSignature,
          defaultSeal: i.defaultSeal
        },
        succFun: res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          if (a == 1) {
            this.get_mySignature()
          } else {
            this.get_mySeal()
          }
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    beforeAvatarUpload(file) {
      const isSize = new Promise(function (resolve, reject) {
        const width = 166
        const height = 166
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = () => {
          const valid = img.width == width && img.height == height
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        i => {
          return file
        },
        () => {
          this.$message({
            message: '选择图片尺寸不等于166*166.请选择合适图片',
            type: 'error'
          })
          return Promise.reject()
        }
      )
      return isSize
    },
    // 生成签名二维码
    Signature() {
      if (this.authenStatus == 1) {
        var asp = []
        for (var i = 0; i < this.mod_mySignature.length; i++) {
          if (this.mod_mySignature[i].remark != '系统签名') {
            asp.push(this.mod_mySignature[i])
          }
        }
        if (asp.length >= 5) {
          this.$message({
            message: '签名数量已达上限，请删除后重新添加',
            type: 'warning'
          })
          return
        } else {
          this.$SIF.httpPost({
            url: this.$SIF._serve.manage + '/function/create/qrcode',
            data: {
              content: this.new_url + '/h5/index.html#/signature?token=' + localStorage.getItem('SET_TOKEN'),
              height: '160',
              width: '160'
            },
            succFun: res => {
              this.add_signature_dialog = true
              this.qrcodeBase64 = res.data.qrcodeBase64
            },
            failFun: res => {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        }
      } else {
        this.$confirm('未认证用户不能上传印章，去认证', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            name: this.userType == 1 ? 'enterpriseAuthe' : 'personalAuthentication'
          })
        })
      }
    },
    img_upload(dt) {
      dt.data['business'] = 'private'
      dt.data['project'] = 'web-sign'
      var that = this
      // 公式  像素/72*25.4
      this.$SIF.uploadImg({
        params: dt,
        succFun: function (res) {
          if (res.data == null) {
            that.del_add(res)
            return
          }
          if (that.companyAuthInfo.resourceEntitys[dt.data.key] && that.companyAuthInfo.resourceEntitys[dt.data.key].fileId) {
            that.$SIF.delFile({
              params: {
                id: that.companyAuthInfo.resourceEntitys[dt.data.key].fileId
              }
            })
          }
          that.companyAuthInfo.resourceEntitys[dt.data.key]['filePath'] = res.data.downloadUrl
          that.companyAuthInfo.resourceEntitys[dt.data.key]['fileId'] = res.data.id
          setTimeout(() => {
            var add_input = document.getElementById('guang_b')
            add_input.type = 'button'
            add_input.style.width = '190px'
            add_input.style.textAlign = 'left'
            var add_input_s = document.getElementById('guang_b_s')
            add_input_s.type = 'button'
            add_input_s.style.width = '190px'
            add_input_s.style.textAlign = 'left'
          }, 800)
        },
        failFun: function (res) {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    del_add(res) {
      var that = this
      this.$message({
        message: res.msg,
        type: 'warning'
      })
    },
    // /eseal-seal/contract-seal/delete
    go_del_seal() {},
    del_seal_2(present) {
      var id = present.id
      this.$SIF.httpGet({
        url: this.$SIF._serve.seal + '/contract-seal/delete/' + id,
        succFun: async res => {
          this.del_seal_dialog_2 = false
          this.loding_s = false
          this.get_certificationFailure()

          this.get_mySeal()

          this.$message({
            message: '操作成功',
            type: 'success'
          })
        },
        failFun: res => {
          this.loding_s = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    del_seal() {
      var id = this.present.id
      this.loding_s = true
      this.$SIF.httpGet({
        url: this.$SIF._serve.signature + '/contract-signature/delete/' + id,
        succFun: res => {
          this.del_seal_dialog = false
          this.loding_s = false
          this.get_mySignature()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        },
        failFun: res => {
          this.loding_s = false
          this.$message({
            message: '操作失败',
            type: 'warning'
          })
        }
      })
    },
    add_seal() {
      // this.height=this.data1.height/72*25.4;
      // this.width=this.data1.width/72*25.4;
      if (!this.companyAuthInfo.name) {
        this.$message({
          message: '印章名称不能为空',
          type: 'warning'
        })
        return
      }

      if (this.companyAuthInfo.size == 1 || this.companyAuthInfo.size == 2) {
        this.companyAuthInfo.size = '40*40'
      } else if (this.companyAuthInfo.size == 3) {
        this.companyAuthInfo.size = '40*30'
      } else if (this.companyAuthInfo.size == 4) {
        this.companyAuthInfo.size = '20*20'
      } else if (this.companyAuthInfo.size == 5) {
        this.companyAuthInfo.size = '38*38'
      }
      this.loding_s = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.seal + '/contract-seal/add/seal',
        data: {
          name: this.companyAuthInfo.name,
          sealType: '0' + this.companyAuthInfo.sealType,
          // size: this.width.toFixed(4) + '*' + this.height.toFixed(4),
          size: this.companyAuthInfo.size,
          sealSaveID: this.companyAuthInfo.resourceEntitys[0].fileId,
          creditCode: this.$SIF.getLocalStorage('userInfo').creditCode
        },
        succFun: res => {
          this.add_seal_dialog = false
          // this.get_mySignature();
          this.companyAuthInfo.name = ''
          this.companyAuthInfo.sealType = 2
          this.companyAuthInfo.size = 1
          this.companyAuthInfo.resourceEntitys[0].fileId = ''
          this.companyAuthInfo.resourceEntitys[0].filePath = ''
          this.get_mySeal()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.loding_s = false
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          this.loding_s = false
        }
      })
    },
    // 获取签名列表
    get_mySignature() {
      var that = this
      that.loading = true
      that.$axios.post(that.$SIF._serve.signature + '/contract-signature/usersignature').then(
        res => {
          if (res.data.code == 10000) {
            var dt = res.data.data,
              arr = []
            if (!dt) {
              that.loading = false
            }
            that.mod_mySignature = dt
            for (var k = 0; k < dt.length; k++) {
              arr.push(dt[k].signatureSaveID)
            }
            dt = that.chunk(dt, 4)
            that.mySignature = dt
            that.$SIF.downloadListFile({
              params: { ids: arr },
              succFun: function (res) {
                that.mySignature_file = res.data
                that.loading = false
              },
              failFun: function () {
                that.loading = false
              }
            })
          }
        },
        res => {
          that.loading = false
        }
      )
    },
    // 获取印章列表
    get_mySeal() {
      var url = this.userType == 0 ? this.$SIF._serve.manage + '/query/auth-seal' : this.$SIF._serve.seal + '/contract-seal/companySeal'
      var that = this
      that.loading = true
      if (this.userType == 1) {
        var date = {
          name: '',
          sealType: ''
        }
      }

      that.$axios.post(url, date).then(
        res => {
          if (res.data.code == 10000) {
            var dt = res.data.data,
              arr = []
            if (!dt) {
              that.loading = false
              return
            }
            for (var n = 0; n < dt.length; n++) {
              if (dt[n].sealType == '01') {
                this.ndt.push(dt[n])
              }
            }
            if (this.ndt.length > 0) {
              this.companyAuthInfo.sealType = 2
            } else {
              this.companyAuthInfo.sealType = 1
            }
            that.mo_myseal = dt
            if (that.certificationData.length > 0) {
              for (var d = 0; d < that.certificationData.length; d++) {
                dt.push(that.certificationData[d])
              }
            }
            if (!dt[0]) {
              that.loading = false
              return
            }
            if (dt) {
              let showSeals = dt.filter(item => !item.whetherOnline || (item.whetherOnline && item.status === 1))
              that.nweData = dt.filter(item => !item.whetherOnline)
              that.mySeal = that.chunk(showSeals, 4)
              // debugger
              // for (var k = 0; k < dt.length; k++) {
              //   arr.push(dt[k].sealSaveID)
              // }
              // this.nweData = []
              // for (var io = 0; io < dt.length; io++) {
              //   if (dt[io].whetherOnline == 0) {
              //     this.nweData.push(dt[io])
              //   }
              // }
              // dt = that.chunk(dt, 4)
              // that.mySeal = dt
              that.$SIF.downloadListFile({
                params: { ids: showSeals.map(item => item.sealSaveID) },
                succFun: function (res) {
                  that.mySeal_file = res.data
                  that.loading = false
                },
                failFun: function (res) {
                  that.loading = false
                }
              })
              //  获取验证失败的印章
            }
          } else {
            that.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        },
        res => {
          that.loading = false
        }
      )
    },
    chunk(arr, size) {
      var rsArr = []
      for (var i = 0; i < arr.length; i += size) {
        var tempArr = []
        for (var j = 0; j < size && i + j < arr.length; j++) {
          tempArr.push(arr[i + j])
        }
        rsArr.push(tempArr)
      }
      return rsArr
    }
  }
}
</script>
<style scoped type="text/css">
.signature_div {
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
}

._el-form {
  text-align: center;
}

.mod_img {
  width: 70%;
  margin: 0 auto;
  text-align: center;
}

.xiey {
  cursor: pointer;
  color: rgba(49, 202, 132, 1);
  text-decoration: underline;
}

.signature_test {
  font-size: 12px;
  color: #737373;
}

#pay {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.No_data {
  width: 100%;
  text-align: center;
  color: #6a6a6a;
  padding-top: 70px;
}

.mySignature {
  margin-bottom: 10px;
}

.list .img {
  width: 100%;
  border-radius: 3px;
  opacity: 0.8;
  border: 1px solid rgba(49, 202, 132, 1);
  position: relative;
  text-align: center;
  min-height: 180px;
}

.img_shen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  left: 0;
  text-align: right;
  color: #ffffff;
  line-height: 170px;
}

.mySeal .el-image {
  width: 129px;
  margin: 20px auto;
}

.list .img div {
  z-index: 9;
}

.list .img .delButn {
  position: absolute;
  width: 20px;
  height: 20px;
  color: rgba(49, 202, 132, 1);
  right: -10px;
  top: -10px;
  cursor: pointer;
  display: none;
  z-index: 10;
}

.list .img .delButn > svg {
  width: 100%;
  height: 100%;
}

.list .img .botButn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 23px;
  line-height: 23px;
  background: rgba(49, 202, 132, 0.2);
  font-size: 0;
  color: #278e60;
  display: none;
}

.list .active .botButn,
.list .active .delButn {
  display: block;
}

.list .img:visited .delButn,
.list .img:visited .botButn {
  display: block;
}

.list .img:hover .delButn,
.list .img:hover .botButn {
  display: block;
}

.list .img .botButn > div {
  display: inline-block;
  width: 50%;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  line-height: 23px;
}

.list .img .botButn img {
  display: inline-block;
  vertical-align: middle;
  margin: 5px 0;
  width: 13px;
  height: 13px;
}

.list .img .default {
  position: absolute;
  top: 6px;
  left: 6px;
}

.default_right {
  position: absolute;
  top: 5px;
  right: 5px;
}

.default_right img {
  width: 20px;
  height: 20px;
  display: block;
}

.list .img .default img {
  width: 13px;
  height: 13px;
  display: block;
}

.img >>> .el-image__inner--center {
  position: static !important;
  transform: translate(0%, 0%) !important;
}

.list .msg {
  background: rgba(244, 244, 244, 1);
  line-height: 14px;
  padding: 5px 15px;
  font-size: 12px;
  color: #a1a1a1;
  border-radius: 3px;
  width: 204px;
  margin: 0 auto;
  background: rgba(49, 202, 132, 0.05);
  padding-top: 10px;
}

.list .msg > div {
  text-align: left;
  min-height: 25px;
  overflow: hidden;
}

.list .msg > div .key {
  display: inline-block;
  width: 60px;
}

.list .msg > div .text {
  width: 100px;
  /*display: inline-block;*/
  float: right;
  vertical-align: top;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list .carousel_item > div > div {
  width: 220px;
  margin: 0 auto;
}

.carousel_item > div {
  width: 25%;
}

/* .carousel_item > div:first-child {
      margin-left: 0;
    } */
</style>
<style scoped type="text/css">
.mySignature /deep/ .img {
  min-height: 115px !important;
}

.list .el-carousel__item {
  width: 90%;
  padding: 0 10px;
  margin: 0px 5%;
  padding-top: 10px;
  /* display: flex;
        justify-content: s;
        justify-items: left; */
}

.list .el-carousel__item > div {
  display: inline-block;
  vertical-align: top;
}

.list .el-carousel__arrow {
  border: 1px #31ca84 solid;
  background: none;
  color: #31ca84;
  font-size: 20px;
}

.list .el-carousel__arrow:hover {
  background: none;
}

.affirm_add_seal {
  font-size: 12px;
  color: #bababa;
  text-align: center;
  width: 80%;
  margin: 0 auto;
  border: 1px dashed #31ca84;
  padding: 27px 0;
}

.add_seal_test_1 {
  color: #bababa;
}

.affirm_add_seal .el-upload:focus {
  color: #bababa;
}

.affirm_add_seal .el-image {
  /*height: 166px;*/
  width: 166px;
}

.affirm_test {
  font-size: 12px;
  color: #cfd0cf;
  width: 80%;
  margin: 0 auto;
  padding: 13px 0;
  text-align: left;
}

.add_seal_test {
  font-size: 14px;
  color: #31ca84;
}

.affirm_del_seal {
  font-size: 14px;
  color: #5f5f5f;
  text-align: center;
}

.affirm_del_seal .el-image {
  width: 182px;
  border: 2px solid rgba(206, 62, 62, 0.38);
  border-radius: 3px;
  margin-top: 20px;
}

.affirm_del_seal .hint {
  font-size: 12px;
  color: #f78b8b;
  margin: 16px 0;
}

.affirm_del_seal >>> .el-image__inner--center {
  position: static !important;
  transform: translate(0%, 0%) !important;
}

.mod_img >>> .el-image__inner--center {
  position: static !important;
  transform: translate(0%, 0%) !important;
}

.account-butn {
  width: 282px;
  height: 47px;
  background: rgba(25, 188, 115, 1);
  border-radius: 24px;
  line-height: 47px;
  color: #fff;
  font-size: 16px;
  margin-top: 22px;
  cursor: pointer;
  text-align: center;
  padding: 0;
}

.image-slot_one {
  padding-top: 33px;
}

.image-slot_one p {
  font-weight: 500;
  color: rgba(255, 118, 23, 1);
  line-height: 20px;
}
</style>